/**
 * Camada Layouts / grids — tipos de tela do UI Card (Oikos Feature Card + UI Card, slide 9).
 * Tipo de tela = como a informação se organiza (não confundir com navegação).
 * Tela final = Tipo de tela + Navegação + Componentes + Estados.
 */

const LAYOUT_CATALOG = [
  {
    grupo: 'Tipos de tela',
    items: [
      {
        id: 'layout-overview',
        nome: 'Visão geral dos tipos',
        paraQue:
          'Os 6 tipos do UI Card: como a informação se organiza antes de escolher componentes.',
        variantes: [{ id: 'A', nome: 'Wireframes + definições', mock: 'layoutOverview' }],
      },
      {
        id: 'layout-z',
        nome: 'Clássico em Z',
        paraQue: 'Visão geral e diagnóstico — 4 faixas de 25% → herói 75% / apoio 25% → base 50%/50%. A faixa marca a divisão; o bloco dentro dela não precisa ser um KPI.',
        grade: {
          linhas: [
            { zonas: [{ nome: 'Faixa', largura: '25%', repete: 4 }] },
            {
              zonas: [
                { nome: 'Herói', largura: '75%', comps: ['chart'] },
                { nome: 'Apoio', largura: '25%', comps: ['alert-banner', 'card-panel', 'stepper'] },
              ],
            },
            {
              zonas: [
                { nome: 'Base', largura: '50%', comps: ['chart', 'table'] },
                { nome: 'Base', largura: '50%', comps: ['chart', 'table'] },
              ],
            },
          ],
        },
        variantes: [{ id: 'A', nome: 'Zonas e espaçamento', mock: 'layoutZ' }],
      },
      {
        id: 'layout-70-30',
        nome: '70 / 30',
        paraQue: '4 faixas de 25% · principal 70% / apoio 30% na altura restante — corte diferente do Z (75/25).',
        grade: {
          linhas: [
            { zonas: [{ nome: 'Faixa', largura: '25%', repete: 4 }] },
            {
              zonas: [
                { nome: 'Principal', largura: '70%', comps: ['form-layout', 'table', 'chart'] },
                { nome: 'Apoio', largura: '30%', comps: ['stepper', 'alert-banner', 'card-panel'] },
              ],
            },
          ],
        },
        variantes: [{ id: 'A', nome: 'Zonas e espaçamento', mock: 'layout7030' }],
      },
      {
        id: 'layout-explore',
        nome: 'Exploração',
        paraQue: 'Filtros 25% + 3 faixas de 25% · análise e detalhe nos 75% à direita, preenchendo a altura.',
        grade: {
          linhas: [
            {
              zonas: [
                { nome: 'Filtros', largura: '25%', spanLinhas: 3, comps: ['filter', 'select-async'] },
                { nome: 'Faixa', largura: '25%', repete: 3 },
              ],
            },
            { zonas: [{ nome: 'Análise', largura: '75%', comps: ['chart'] }] },
            { zonas: [{ nome: 'Detalhe', largura: '75%', comps: ['table'] }] },
          ],
        },
        variantes: [{ id: 'A', nome: 'Zonas e espaçamento', mock: 'layoutExplore' }],
      },
      {
        id: 'layout-exec',
        nome: 'Executiva',
        paraQue: 'Síntese para decisão rápida — resumo 100% + 4 faixas de 25% + um único gráfico que preenche o resto.',
        grade: {
          linhas: [
            { zonas: [{ nome: 'Resumo', largura: '100%', comps: ['card-panel', 'status-badge', 'alert-banner'] }] },
            { zonas: [{ nome: 'Faixa', largura: '25%', repete: 4 }] },
            { zonas: [{ nome: 'Gráfico', largura: '100%', limite: 1, comps: ['chart'] }] },
          ],
        },
        variantes: [{ id: 'A', nome: 'Zonas e espaçamento', mock: 'layoutExec' }],
      },
      {
        id: 'layout-compare',
        nome: 'Comparativa',
        paraQue: 'Diferenças, desvios e variações — 3 faixas de 33%, painéis 50/50 na altura principal e desvio 100%.',
        grade: {
          linhas: [
            { zonas: [{ nome: 'Faixa', largura: '33%', repete: 3 }] },
            {
              zonas: [
                { nome: 'Série A', largura: '50%', comps: ['chart'] },
                { nome: 'Série B', largura: '50%', comps: ['chart'] },
              ],
            },
            { zonas: [{ nome: 'Desvios', largura: '100%', comps: ['table', 'alert-banner'] }] },
          ],
        },
        variantes: [{ id: 'A', nome: 'Zonas e espaçamento', mock: 'layoutCompare' }],
      },
      {
        id: 'layout-ops',
        nome: 'Operacional / TV',
        paraQue: 'Monitoramento contínuo — status 50/50 e feed 100%, legível à distância.',
        grade: {
          linhas: [
            {
              zonas: [
                { nome: 'Status', largura: '50%' },
                { nome: 'Fila', largura: '50%', comps: ['alert-banner', 'table'] },
              ],
            },
            { zonas: [{ nome: 'Feed', largura: '100%', comps: ['table', 'stepper'] }] },
          ],
        },
        variantes: [{ id: 'A', nome: 'Zonas e espaçamento', mock: 'layoutOps' }],
      },
    ],
  },
  {
    grupo: 'Espaçamento e alocação',
    items: [
      {
        id: 'layout-spacing',
        nome: 'Escala de espaçamento',
        paraQue:
          'Gaps entre zonas e componentes ao montar a tela (não confundir com tipografia/letter-spacing).',
        tokens: [
          { id: '--lyt-gap-xs', px: 8, uso: 'Entre as faixas da mesma linha; chips; ícone e rótulo.' },
          { id: '--lyt-gap-sm', px: 12, uso: 'Entre campos em formulário compacto.' },
          { id: '--lyt-gap-md', px: 16, uso: 'Entre componentes dentro da mesma zona.' },
          { id: '--lyt-gap-lg', px: 24, uso: 'Entre zonas (uma linha da grade e a seguinte).' },
          { id: '--lyt-gap-xl', px: 32, uso: 'Respiro de página ou seção principal.' },
        ],
        variantes: [{ id: 'A', nome: 'Tokens de gap', mock: 'layoutSpacing' }],
      },
      {
        id: 'layout-zones',
        nome: 'Alocação de componentes',
        paraQue:
          'Onde vão gráfico, tabela, formulário e apoio em cada tipo — escolha o tipo primeiro. A faixa de 25% é só a divisão.',
        variantes: [{ id: 'A', nome: 'Mapa tipo → componentes', mock: 'layoutZones' }],
      },
    ],
  },
  {
    grupo: 'Navegação (complemento)',
    items: [
      {
        id: 'layout-nav',
        nome: 'Padrões de navegação',
        paraQue:
          'Abas, filtros, drill-down, master-detail, drawer, modal, etapas e breadcrumb. Distinto do tipo de tela.',
        padroes: [
          { nome: 'Abas', id: 'tabs', desc: 'Perspectivas do mesmo objeto sem sair do contexto.' },
          { nome: 'Filtros', id: 'filter', desc: 'Refinar grandes conjuntos de informação.' },
          { nome: 'Drill-down', id: 'table', desc: 'Sair da síntese e aprofundar o detalhe.' },
          { nome: 'Master-Detail', id: 'drawer', desc: 'Lista de registros com detalhe do item selecionado.' },
          { nome: 'Drawer', id: 'drawer', desc: 'Detalhe ou ação lateral sem abandonar a tela.' },
          { nome: 'Modal', id: 'modal-confirm', desc: 'Interrupção pontual para confirmação ou ação.' },
          { nome: 'Etapas', id: 'stepper', desc: 'Processo guiado com sequência obrigatória.' },
          { nome: 'Breadcrumb', id: 'page-header', desc: 'Retorno em estruturas hierárquicas.' },
        ],
        variantes: [{ id: 'A', nome: 'Lista de padrões', mock: 'layoutNav' }],
      },
    ],
  },
]

export function flattenLayoutCatalog() {
  return LAYOUT_CATALOG.flatMap((g) => g.items.map((it) => ({ ...it, grupo: g.grupo })))
}

export default LAYOUT_CATALOG
